<div class="rp-overlay-wrap" *ngIf="state">

  <!-- ── Full Page Loader ───────────────────────────────────────────── -->
  

  <!-- ── Debug Banner ───────────────────────────────────────────────── -->
  <div class="rp-debug-banner" *ngIf="!isLoading">
  
    <div >
      <span class="rp-debug-trips">Trips: {{ tripCount }}</span>
      <span class="rp-debug-divider">│</span>
      <span class="rp-debug-active" [class.rp-debug-active--on]="activeCount > 0">Active: {{ activeCount }}</span>
      <span class="rp-debug-divider">│</span>
      <span class="rp-debug-time">{{ currentTimeLabel }}</span>
    </div>
  </div>

  <!-- ── Control Pill ───────────────────────────────────────────────── -->
  <div class="rp-pill">
    <!-- Play / Pause -->
    <button class="rp-pill-btn rp-pill-btn--play" [appTourAnchor]="'filters.replayPlay'" (click)="togglePlay()" aria-label="Play / Pause">
      <svg *ngIf="!isPlaying" viewBox="0 0 24 24" fill="#007AFF">
        <polygon points="5 3 19 12 5 21 5 3"></polygon>
      </svg>
      <svg *ngIf="isPlaying" viewBox="0 0 24 24" fill="#007AFF">
        <rect x="6" y="4" width="4" height="16"></rect>
        <rect x="14" y="4" width="4" height="16"></rect>
      </svg>
    </button>

    <div class="rp-v-divider"></div>

    <!-- Settings / Tune -->
    <button class="rp-pill-btn rp-pill-btn--tune" (click)="openSettings()" aria-label="Filter settings">
      <svg viewBox="0 0 24 24" fill="none" stroke="#3C3C43" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <line x1="4" y1="21" x2="4" y2="14"></line>
        <line x1="4" y1="10" x2="4" y2="3"></line>
        <line x1="12" y1="21" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12" y2="3"></line>
        <line x1="20" y1="21" x2="20" y2="16"></line>
        <line x1="20" y1="12" x2="20" y2="3"></line>
        <line x1="1" y1="14" x2="7" y2="14"></line>
        <line x1="9" y1="8" x2="15" y2="8"></line>
        <line x1="17" y1="16" x2="23" y2="16"></line>
      </svg>
    </button>

    <!-- Progress Slider -->
    <div class="rp-slider-wrap">
      <input
        type="range"
        class="rp-slider"
        min="0" max="1" step="0.001"
        [value]="progress"
        (input)="onSliderChange(+$any($event.target).value)"
      />
    </div>

    <!-- Speed Chip -->
    <button class="rp-speed-chip" [appTourAnchor]="'filters.replaySpeed'" (click)="cycleSpeed()" aria-label="Playback speed">
      {{ speed }}x
    </button>

    <div class="rp-v-divider"></div>

    <!-- Close -->
    <button class="rp-pill-btn rp-pill-btn--close" [appTourAnchor]="'filters.replayClose'" (click)="close()" aria-label="Exit replay">
      <svg viewBox="0 0 24 24" fill="none" stroke="rgba(0,0,0,0.38)" stroke-width="2.5"
        stroke-linecap="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
</div>